"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var i18next_1 = __importDefault(require("i18next"));
var core_1 = require("@material-ui/core");
var react_redux_1 = require("react-redux");
var constants_1 = require("../../../shared/constants");
var validation_1 = require("../../../shared/util/validation");
var BetaTag_1 = __importDefault(require("../../app/components/widgets/BetaTag"));
var CollapsibleMessage_1 = __importDefault(require("../../app/components/CollapsibleMessage"));
var ConfigOption_1 = __importStar(require("./ConfigOption"));
var PrefixableTextField_1 = __importDefault(require("./PrefixableTextField"));
var types_1 = require("../../app/components/CollapsibleMessage/types");
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b;
    return core_1.createStyles({
        regularText: {
            fontWeight: 400,
        },
        characterCount: {
            marginLeft: 2,
            marginTop: 9,
        },
        linkInformationHeaderWrapper: (_a = {
                display: 'flex',
                alignItems: 'center',
                marginBottom: theme.spacing(1.25),
                marginRight: theme.spacing(2)
            },
            _a[theme.breakpoints.up('md')] = {
                marginRight: theme.spacing(1),
            },
            _a),
        activeText: {
            color: '#6d9067',
        },
        inactiveText: {
            color: '#c85151',
        },
        linkInformationHeader: (_b = {
                marginRight: theme.spacing(2)
            },
            _b[theme.breakpoints.up('md')] = {
                marginRight: theme.spacing(1),
            },
            _b),
        linkInformationDesc: {
            marginBottom: theme.spacing(3),
            fontWeight: 400,
        },
        linkInformationDescHeader: {
            fontWeight: 500,
            marginBottom: theme.spacing(0.5),
        },
        hotlink: {
            color: theme.palette.text.primary,
        },
    });
});
function LinkInfoEditor(_a) {
    var contactEmail = _a.contactEmail, description = _a.description, onContactEmailChange = _a.onContactEmailChange, onDescriptionChange = _a.onDescriptionChange, onContactEmailValidation = _a.onContactEmailValidation, onDescriptionValidation = _a.onDescriptionValidation, isMountedOnCreateUrlModal = _a.isMountedOnCreateUrlModal;
    // Styles used in this component.
    var classes = useStyles();
    var theme = core_1.useTheme();
    var isMobileView = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var emailValidator = react_redux_1.useSelector(function (state) { return state.login.emailValidator; });
    var isContactEmailValid = !contactEmail || emailValidator(contactEmail);
    var isDescriptionValid = description.length <= constants_1.LINK_DESCRIPTION_MAX_LENGTH &&
        validation_1.isPrintableAscii(description);
    react_1.useEffect(function () {
        onContactEmailValidation(isContactEmailValid);
    }, [isContactEmailValid]);
    react_1.useEffect(function () {
        onDescriptionValidation(isDescriptionValid);
    }, [isDescriptionValid]);
    var contactEmailHelp = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: classes.linkInformationDescHeader }, "Contact email"),
        react_1.default.createElement("br", null),
        "Enter an email which the public can contact if they have queries about your short link."));
    var linkDescriptionHelp = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: classes.linkInformationDescHeader }, "Link description"),
        react_1.default.createElement("br", null),
        "Write a description that will help the public understand what your short link is for."));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !isMountedOnCreateUrlModal && (react_1.default.createElement("div", { className: classes.linkInformationHeaderWrapper },
            react_1.default.createElement(core_1.Typography, { variant: "h3", className: classes.linkInformationHeader, color: "primary" }, "Link information"),
            react_1.default.createElement(BetaTag_1.default, null))),
        react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.linkInformationDesc },
            "The information you enter below will be displayed on our",
            ' ',
            react_1.default.createElement("a", { href: "https://go.gov.sg/go-search", className: classes.hotlink },
                react_1.default.createElement("u", null, "GoSearch page (coming soon)")),
            ", and the error page if users are unable to access your short link."),
        react_1.default.createElement(core_1.Typography, { variant: "h4", className: classes.linkInformationHeader, color: "primary" }),
        react_1.default.createElement(ConfigOption_1.default, { title: contactEmailHelp, leading: react_1.default.createElement(PrefixableTextField_1.default, { value: contactEmail, onChange: onContactEmailChange, placeholder: "", helperText: isContactEmailValid
                    ? ''
                    : "This doesn't look like a valid " + i18next_1.default.t('general.emailDomain') + " email.", error: !isContactEmailValid }), trailing: react_1.default.createElement(react_1.default.Fragment, null), wrapTrailing: isMobileView, trailingPosition: ConfigOption_1.TrailingPosition.none }),
        react_1.default.createElement(ConfigOption_1.default, { title: linkDescriptionHelp, leading: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(PrefixableTextField_1.default, { value: description, onChange: onDescriptionChange, error: !isDescriptionValid, placeholder: "Tip: Include your agency name to inform the public who this link belongs to.", helperText: isDescriptionValid
                        ? description.length + "/" + constants_1.LINK_DESCRIPTION_MAX_LENGTH
                        : undefined, multiline: true, rows: 2, rowsMax: isMobileView ? 5 : undefined, FormHelperTextProps: { className: classes.characterCount } }),
                react_1.default.createElement(CollapsibleMessage_1.default, { type: types_1.CollapsibleMessageType.Error, visible: !isDescriptionValid, position: types_1.CollapsibleMessagePosition.Static, timeout: 0 }, validation_1.isPrintableAscii(description)
                    ? description.length + "/200"
                    : 'Description should only contain alphanumeric characters and symbols.')), trailing: react_1.default.createElement(react_1.default.Fragment, null), wrapTrailing: isMobileView, trailingPosition: ConfigOption_1.TrailingPosition.none })));
}
exports.default = LinkInfoEditor;
